import { observer } from 'mobx-react';
import React from 'react';
import { PromiseMessage } from '../../../lib/components';
import { promiseStates, ReactNodeGenerator } from '../../../lib/helpers';
import HomeworkLoaderControls from '../parts/HomeworkLoaderControls';
import { StudentHomeworkSceneStore } from './StudentHomeworkSceneStore';
import { StudentHomeworkTabs } from './StudentHomeworkTabs';
import { withTranslation, WithTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

const ps = promiseStates;

function* renderer(store: StudentHomeworkSceneStore, t: any): ReactNodeGenerator {
  yield <HomeworkLoaderControls key="homework-loader-controls"
    store={store} />;

  if (!store.canConnectToHub)
    return;

  const { snapshotState } = store;
  yield (
    <PromiseMessage key="lesson-loader-state"
      label={t('homework.loading')}
      state={snapshotState}
      align="right" />);

  if (ps.isRejected(snapshotState)) {
    yield (
      <div className="row" key="lesson-load-action">
        <div className="col-auto ml-auto">
          <button type="button" className="btn btn-primary"
            onClick={store.loadLesson}>
            Load lesson
          </button>
        </div>
      </div>
    );
  }

  const homeworkState = store.hubStore.state.homeworkState!;
  if (homeworkState === null)
    return;

  yield (<StudentHomeworkTabs store={store} key="homework-lesson-tabs" />);
}

interface Props extends WithTranslation {
  id: number;
}

@observer
class StudentHomeworkScene extends React.Component<Props> {
  readonly store: StudentHomeworkSceneStore;
  t: TFunction;

  constructor(props: Readonly<Props>) {
    super(props);

    this.t = props.t;
    this.store = new StudentHomeworkSceneStore(props.id);
  }

  componentDidMount() {
    this.store.loadHomework();
  }

  render() {
    return Array.from(renderer(this.store, this.t));
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}

export default withTranslation()(StudentHomeworkScene);